import { render, staticRenderFns } from "./SubjectsTab.vue?vue&type=template&id=611246e6&scoped=true"
import script from "./SubjectsTab.vue?vue&type=script&lang=js"
export * from "./SubjectsTab.vue?vue&type=script&lang=js"
import style0 from "./SubjectsTab.vue?vue&type=style&index=0&id=611246e6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611246e6",
  null
  
)

export default component.exports